const apiUrl = localStorage.getItem('apiUrl');

export default {
  api: apiUrl || process.env.VUE_APP_API_URL,
  apiSignalR: process.env.VUE_APP_API_SIGNALR,
  apiTimeout: 50 * 1000,
  baseUrl: process.env.VUE_APP_BASE_URL,
  appTitle: process.env.VUE_APP_MAIN_TITLE,
  erpApiUrl: process.env.VUE_APP_ERP_API_URL,
};
